import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Link } from '@mui/material'

const fmt = (n) => n != null ? `$ ${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—'

function CreditField({ label, value, valueColor }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
      <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', fontWeight: 700 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: valueColor || '#262626', fontWeight: 500 }}>
        {value}
      </Typography>
    </Box>
  )
}
CreditField.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.string, valueColor: PropTypes.string }

function CustomerCreditInfoBarV2({ orderDetail }) {
  if (!orderDetail) return null
  const creditColor = orderDetail.availableCredit != null && orderDetail.availableCredit < 0 ? '#cc3f0c' : '#262626'

  return (
    <Box sx={{
      border: '1px solid #e7e7e7',
      borderRadius: 2,
      p: 2,
      backgroundColor: '#fff',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.95rem', color: '#262626', fontWeight: 700 }}>
          Customer Credit Info
        </Typography>
        <Link href='#' underline='hover' sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#1a8a6a' }}>
          View A/R Ageing
        </Link>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <CreditField label='Credit Limit :' value={fmt(orderDetail.creditLimit)} />
        <CreditField label='A/R Owing :' value={fmt(orderDetail.arOutstanding)} />
        <CreditField label='Open Order Value :' value={fmt(orderDetail.openOrderValue)} />
        <CreditField label='Available Credit :' value={fmt(orderDetail.availableCredit)} valueColor={creditColor} />
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', fontWeight: 700 }}>
            Last Payment :
          </Typography>
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', fontWeight: 500 }}>
            {fmt(orderDetail.lastPaymentAmount)}
            {orderDetail.lastPaymentDate && (
              <Box component='span' sx={{ fontSize: '0.72rem', color: '#888', ml: 0.75 }}>
                {orderDetail.lastPaymentDate}
              </Box>
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

CustomerCreditInfoBarV2.propTypes = { orderDetail: PropTypes.object }

export default CustomerCreditInfoBarV2
